import { render, staticRenderFns } from "./advertBanner.vue?vue&type=template&id=4e37c480&scoped=true"
import script from "./advertBanner.vue?vue&type=script&lang=js"
export * from "./advertBanner.vue?vue&type=script&lang=js"
import style0 from "./advertBanner.vue?vue&type=style&index=0&id=4e37c480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e37c480",
  null
  
)

export default component.exports